import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { useReactToPrint } from "react-to-print";

import { useRootStore } from "../../../../store/contexts";
import { ShowDateTime } from "../../../common/controls";
import { ShowNumber } from "../../../common/controls";
import { InputCodeEditor } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type AiSearchConversationViewFormProps = {
  onPrint?: (handlePrint: () => void) => void;
  onCancel?: () => void;
  onEdit?: () => void;
  showToolbox?: boolean;
  startedAtValue?: { displayId: string; id: string } | null;
  startedAt: Date | null;
  lastMessageAtValue?: { displayId: string; id: string } | null;
  lastMessageAt: Date | null;
  messageCountValue?: { displayId: string; id: string } | null;
  messageCount: number;
  messagesValue?: { displayId: string; id: string } | null;
  messages: string;
  contextValue?: { displayId: string; id: string } | null;
  context: string;
};

export const AiSearchConversationViewForm: React.FC<AiSearchConversationViewFormProps> =
  observer(
    ({
      onPrint = () => {},
      onCancel = () => {},
      onEdit,
      showToolbox = true,
      startedAt = null,
      lastMessageAt = null,
      messageCount = 0,
      messages = "{}",
      context = "{}",
    }) => {
      const rootStore = useRootStore();
      const { langStore } = rootStore;

      const componentRef = useRef(null);
      const handlePrint = useReactToPrint({
        content: () => componentRef.current,
      });

      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              editForm={onEdit}
              printForm={() => onPrint(handlePrint)}
              closeForm={() => onCancel()}
            />
          )}
          <Box ref={componentRef}>
            <GroupContainer
              id="null"
              title={langStore.groupAiSearchConversationLabel}
              collapsible={false}
            >
              <FormControl fullWidth>
                <ShowDateTime
                  value={startedAt}
                  label={langStore.AiSearchConversationStartedAtLabel}
                />
                <ShowDateTime
                  value={lastMessageAt}
                  label={langStore.AiSearchConversationLastMessageAtLabel}
                />
                <ShowNumber
                  value={messageCount}
                  label={langStore.AiSearchConversationMessageCountLabel}
                />
                <InputCodeEditor
                  value={messages}
                  onChange={() => {}}
                  label={langStore.AiSearchConversationMessagesLabel}
                  language="json"
                  readOnly={true}
                />
                <InputCodeEditor
                  value={context}
                  onChange={() => {}}
                  label={langStore.AiSearchConversationContextLabel}
                  language="json"
                  readOnly={true}
                />
              </FormControl>
            </GroupContainer>
          </Box>
        </Grid>
      );
    }
  );
